import { Controller } from "stimulus"
import Chart from 'chart.js/auto';

export default class extends Controller {
  static targets = ["content"];

  connect() {
    const keys = JSON.parse(this.data.get("keys"));
    const datasets = JSON.parse(this.data.get("datasets"));
    let color = this.data.get("colors");
    if (typeof color === "string" && color.startsWith("[")) {
      color = JSON.parse(color);
    }

    new Chart(this.contentTarget, {
      type: 'bar',
      data: {
        labels: keys,
        datasets: [{
          label: '',
          data: datasets,
          backgroundColor: color,
          borderColor: color,
          borderWidth: 0,
          borderRadius: 6,
          borderSkipped: false,
          hoverBackgroundColor: color,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#0E1110',
            titleColor: '#DDDDD6',
            bodyColor: '#FFFFFF',
            titleFont: { size: 12, weight: '600' },
            bodyFont: { size: 15, weight: '700', family: "'Inter', system-ui, sans-serif" },
            padding: 12,
            cornerRadius: 8,
            displayColors: false,
            callbacks: {
              label: (ctx) => this.formatAmount(ctx.raw)
            }
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              color: '#9A9A8E',
              font: { size: 11, weight: '500' },
              padding: 8,
            },
          },
          y: {
            border: { display: false },
            grid: {
              color: '#EEEEE8',
              drawBorder: false,
            },
            ticks: {
              maxTicksLimit: 4,
              color: '#9A9A8E',
              font: { size: 11, weight: '500' },
              padding: 8,
              callback: (value) => this.formatAmount(value),
            },
          }
        }
      }
    });
  }

  formatAmount(value) {
    if (value >= 1000000) return (value / 1000000).toFixed(1) + ' M';
    if (value >= 1000) return (value / 1000).toFixed(0) + ' k';
    return value;
  }
}
